export const apiUrl = process.env.API_URL;
export const root_url = process.env.VUE_APP_ROOT_API;
export const version = process.env.VERSION;
export const userTokenStorageKey = 'APP_USER_TOKEN';
export const authDisabled = false;
export const bridgeAngularJS = false;
export const permanent = true;
export const PermAdminRole = "Administrator";
export const DefaultPermissions = {};
export const Debug = process.env.NODE_ENV !== "production";
export const BaseURL = process.env.BASE_URL;